<template>
  <v-layout>
    <v-dialog :modelValue="dialog" @click:outside="$emit('updateDialog', false)" @keydown.esc="$emit('updateDialog', false)" max-width="500px" transition="dialog-bottom-transition">
      <template v-slot:activator="{ props }">
        <v-btn flat class="mb-3 btn-second" v-bind="props" @click="$emit('updateDialog', true)">{{ button_name }}</v-btn>
      </template>

      <v-card>
        <v-form @submit.prevent ref="form" v-model="valid" v-on:submit.prevent="createItem">
          <v-card-title>
            <span class="headline">{{ modal_title }}</span>
          </v-card-title>

          <v-card-text>
            <!-- START FORM DIALOG -->
            <div class="row">
              <div class="col-md-12">
                <v-text-field label="Nombre*" v-model="item.name" :disabled="disabled" :rules="[rules.required]"></v-text-field>

                <v-select label="Tipo*" v-model="item.printer_type" :items="printer_types" :disabled="disabled" :rules="[rules.required]"></v-select>

                <v-text-field :label="isCustom ? 'IP*' : 'IP'" v-model="item.ip" :disabled="disabled" :rules="[isCustom ? rules.required : rules.notRequired]"></v-text-field>

                <v-text-field :label="isCustom ? 'Puerto*' : 'Puerto'" v-model="item.port" :disabled="disabled" :rules="[isCustom ? rules.required : rules.notRequired]"></v-text-field>

                <v-text-field
                  v-if="isCustom"
                  label="Socket*"
                  hint="URL base del socket"
                  v-model="item.printer_socket"
                  :disabled="disabled"
                  :rules="[rules.required, (v) => !v || v.length <= 50 || 'Maximo 50 caracteres.']"
                ></v-text-field>

                <v-combobox
                  v-model="item.ubicacion"
                  name="ubicacion"
                  item-title="code"
                  item-value="id"
                  :items="ubicaciones"
                  label="Ubicacion de empaquetado*"
                  autocomplete="off"
                  :disabled="disabled"
                  :rules="[rules.requiredComboBox]"
                  clearable
                ></v-combobox>
              </div>
            </div>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="$emit('updateDialog', false)">Cerrar</v-btn>
            <v-btn color="success" text type="submit" :loading="loading" v-if="!disabled">{{ formBtn }}</v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { ubicacionService } from "@/libs/ws/ubicacionService";
import ValidMixin from "@/mixins/ValidMixin.vue";
import { PRINTER_TYPE_ZEBRA, PRINTER_TYPE_CUSTOM } from "@/mixins/BrowserPrint.vue";
export default {
  mixins: [ValidMixin],
  props: {
    service: Object,
    button_name: String,
    modal_title: String,
    page_title: String,
    formBtn: String,
    dialog: Boolean,
    updateDialog: Function,
    loadList: Function,
    editItem: Object,
  },
  data() {
    return {
      printer_types: [PRINTER_TYPE_ZEBRA, PRINTER_TYPE_CUSTOM],
      disabled: false,
      ubicaciones: [],
      loading: false,
      item: {
        id: "",
        name: "",
        printer_type: PRINTER_TYPE_ZEBRA,
        ip: "",
        port: "",
        printer_socket: null,
        ubicacion: null,
      },
      defaultItem: null,
    };
  },
  computed: {
    isCustom() {
      return this.item.printer_type == PRINTER_TYPE_CUSTOM;
    },
  },
  watch: {
    dialog() {
      if (this.dialog) {
        this.disabled = this.formBtn == "";

        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }

        if (this.editItem != null && this.editItem.id > 0) {
          this.item = JSON.parse(JSON.stringify(this.editItem));
        } else {
          if (this.defaultItem != null) this.item = JSON.parse(JSON.stringify(this.defaultItem));
        }
      }
    },
  },
  mounted() {
    this.loadUbicaciones();
    this.defaultItem = JSON.parse(JSON.stringify(this.item));
  },
  methods: {
    loadUbicaciones() {
      ubicacionService
        .filter({ allow_packing: true })
        .then((response) => {
          this.ubicaciones = response.result.list;
        })
        .catch((e) => {
          console.log("service.load error");
          console.log(e);
        });
    },
    createItem() {
      if (this.loading) return;

      if (this.valid) {
        this.loading = true;

        var data = {
          id: this.item.id,
          name: this.item.name,
          printer_type: this.item.printer_type,
          ip: this.item.ip,
          port: this.item.port,
          printer_socket: this.isCustom ? this.item.printer_socket : null,
          ubicacion: { id: this.item.ubicacion.id },
        };

        if (this.item.id > 0) {
          this.service
            .update(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("La " + this.modal_title + " se modifico correctamente.");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((response) => {
              this.toast.error(response.msg);
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.service
            .create(data)
            .then((response) => {
              if (response.status) {
                this.toast.success("La " + this.modal_title + " se creo correctamente");
                this.$emit("updateDialog", false);
                this.$emit("loadList");
              } else {
                if (Object.prototype.hasOwnProperty.call(response, "message")) {
                  this.toast.error(response.message);
                } else {
                  this.toast.error(response.msg);
                }
              }
            })
            .catch((e) => {
              this.toast.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      }
    },
  },
};
</script>
